module.exports = __webpack_public_path__ + "static/media/client-img1.c4897d53.jpg";